/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ConfirmShipmentDoctorApiInContract,
  ConfirmShipmentDoctorApiOutContract,
  CreateShippingLabelDoctorApiInContract,
  CreateShippingLabelDoctorApiOutContract,
  ErrorApiOutContract,
  GetShippingRatesDoctorApiInContract,
  GetShippingRatesDoctorApiOutContract,
  OrderFulfillmentDetailDoctorApiOutContract,
  ShipToAddressOverrideStaffApiInContract,
  VoidShippingLabelDoctorApiOutContract
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get fulfillment detail for a pharmacy order, including per-item selection data. `CanTriggerFulfillment` is
true for QuickMD Pharmacy orders at the caller's pharmacy that are `onhold`, or `sent` for 15 minutes
or more (and not yet submitted to the pharmacy).
 */
export const getPatientsPatientIdPharmacyOrdersOrderId = (
    patientId: string,
    orderId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<OrderFulfillmentDetailDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/pharmacy/orders/${encodeURIComponent(String(orderId))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdPharmacyOrdersOrderIdInfiniteQueryKey = (patientId?: string,
    orderId?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}/pharmacy/orders/${orderId}`
    ] as const;
    }

export const getGetPatientsPatientIdPharmacyOrdersOrderIdQueryKey = (patientId?: string,
    orderId?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}/pharmacy/orders/${orderId}`
    ] as const;
    }

    
export const getGetPatientsPatientIdPharmacyOrdersOrderIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>>, TError = void | ErrorApiOutContract>(patientId: string,
    orderId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPharmacyOrdersOrderIdInfiniteQueryKey(patientId,orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>> = ({ signal }) => getPatientsPatientIdPharmacyOrdersOrderId(patientId,orderId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId && orderId), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPharmacyOrdersOrderIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>>
export type GetPatientsPatientIdPharmacyOrdersOrderIdInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPharmacyOrdersOrderIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fulfillment detail for a pharmacy order, including per-item selection data. `CanTriggerFulfillment` is
true for QuickMD Pharmacy orders at the caller's pharmacy that are `onhold`, or `sent` for 15 minutes
or more (and not yet submitted to the pharmacy).
 */

export function useGetPatientsPatientIdPharmacyOrdersOrderIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPharmacyOrdersOrderIdInfiniteQueryOptions(patientId,orderId,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get fulfillment detail for a pharmacy order, including per-item selection data. `CanTriggerFulfillment` is
true for QuickMD Pharmacy orders at the caller's pharmacy that are `onhold`, or `sent` for 15 minutes
or more (and not yet submitted to the pharmacy).
 */
export const prefetchGetPatientsPatientIdPharmacyOrdersOrderIdInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string,
    orderId: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdPharmacyOrdersOrderIdInfiniteQueryOptions(patientId,orderId,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdPharmacyOrdersOrderIdQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError = void | ErrorApiOutContract>(patientId: string,
    orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPharmacyOrdersOrderIdQueryKey(patientId,orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>> = ({ signal }) => getPatientsPatientIdPharmacyOrdersOrderId(patientId,orderId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId && orderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPharmacyOrdersOrderIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>>
export type GetPatientsPatientIdPharmacyOrdersOrderIdQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPharmacyOrdersOrderId<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderId<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderId<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fulfillment detail for a pharmacy order, including per-item selection data. `CanTriggerFulfillment` is
true for QuickMD Pharmacy orders at the caller's pharmacy that are `onhold`, or `sent` for 15 minutes
or more (and not yet submitted to the pharmacy).
 */

export function useGetPatientsPatientIdPharmacyOrdersOrderId<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPharmacyOrdersOrderIdQueryOptions(patientId,orderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get fulfillment detail for a pharmacy order, including per-item selection data. `CanTriggerFulfillment` is
true for QuickMD Pharmacy orders at the caller's pharmacy that are `onhold`, or `sent` for 15 minutes
or more (and not yet submitted to the pharmacy).
 */
export const prefetchGetPatientsPatientIdPharmacyOrdersOrderIdQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string,
    orderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdPharmacyOrdersOrderIdQueryOptions(patientId,orderId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdPharmacyOrdersOrderIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError = void | ErrorApiOutContract>(patientId: string,
    orderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPharmacyOrdersOrderIdQueryKey(patientId,orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>> = ({ signal }) => getPatientsPatientIdPharmacyOrdersOrderId(patientId,orderId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPharmacyOrdersOrderIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>>
export type GetPatientsPatientIdPharmacyOrdersOrderIdSuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPharmacyOrdersOrderIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fulfillment detail for a pharmacy order, including per-item selection data. `CanTriggerFulfillment` is
true for QuickMD Pharmacy orders at the caller's pharmacy that are `onhold`, or `sent` for 15 minutes
or more (and not yet submitted to the pharmacy).
 */

export function useGetPatientsPatientIdPharmacyOrdersOrderIdSuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPharmacyOrdersOrderIdSuspenseQueryOptions(patientId,orderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdPharmacyOrdersOrderIdSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>>, TError = void | ErrorApiOutContract>(patientId: string,
    orderId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPharmacyOrdersOrderIdInfiniteQueryKey(patientId,orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>> = ({ signal }) => getPatientsPatientIdPharmacyOrdersOrderId(patientId,orderId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPharmacyOrdersOrderIdSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>>
export type GetPatientsPatientIdPharmacyOrdersOrderIdSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPharmacyOrdersOrderIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fulfillment detail for a pharmacy order, including per-item selection data. `CanTriggerFulfillment` is
true for QuickMD Pharmacy orders at the caller's pharmacy that are `onhold`, or `sent` for 15 minutes
or more (and not yet submitted to the pharmacy).
 */

export function useGetPatientsPatientIdPharmacyOrdersOrderIdSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderId>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPharmacyOrdersOrderIdSuspenseInfiniteQueryOptions(patientId,orderId,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get shipping rates for a pharmacy order
 */
export const postPatientsPatientIdPharmacyOrdersOrderIdShippingRates = (
    patientId: string,
    orderId: string,
    getShippingRatesDoctorApiInContract: GetShippingRatesDoctorApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<GetShippingRatesDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/pharmacy/orders/${encodeURIComponent(String(orderId))}/shipping-rates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getShippingRatesDoctorApiInContract, signal
    },
      options);
    }
  


export const getPostPatientsPatientIdPharmacyOrdersOrderIdShippingRatesMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdShippingRates>>, TError,{patientId: string;orderId: string;data: GetShippingRatesDoctorApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdShippingRates>>, TError,{patientId: string;orderId: string;data: GetShippingRatesDoctorApiInContract}, TContext> => {

const mutationKey = ['postPatientsPatientIdPharmacyOrdersOrderIdShippingRates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdShippingRates>>, {patientId: string;orderId: string;data: GetShippingRatesDoctorApiInContract}> = (props) => {
          const {patientId,orderId,data} = props ?? {};

          return  postPatientsPatientIdPharmacyOrdersOrderIdShippingRates(patientId,orderId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPatientsPatientIdPharmacyOrdersOrderIdShippingRatesMutationResult = NonNullable<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdShippingRates>>>
    export type PostPatientsPatientIdPharmacyOrdersOrderIdShippingRatesMutationBody = GetShippingRatesDoctorApiInContract
    export type PostPatientsPatientIdPharmacyOrdersOrderIdShippingRatesMutationError = void | ErrorApiOutContract

    /**
 * @summary Get shipping rates for a pharmacy order
 */
export const usePostPatientsPatientIdPharmacyOrdersOrderIdShippingRates = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdShippingRates>>, TError,{patientId: string;orderId: string;data: GetShippingRatesDoctorApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdShippingRates>>,
        TError,
        {patientId: string;orderId: string;data: GetShippingRatesDoctorApiInContract},
        TContext
      > => {

      const mutationOptions = getPostPatientsPatientIdPharmacyOrdersOrderIdShippingRatesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Create a ZPL shipping label. The ZPL is returned to the caller for local Zebra printing.
 */
export const postPatientsPatientIdPharmacyOrdersOrderIdLabels = (
    patientId: string,
    orderId: string,
    createShippingLabelDoctorApiInContract: CreateShippingLabelDoctorApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<CreateShippingLabelDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/pharmacy/orders/${encodeURIComponent(String(orderId))}/labels`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createShippingLabelDoctorApiInContract, signal
    },
      options);
    }
  


export const getPostPatientsPatientIdPharmacyOrdersOrderIdLabelsMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdLabels>>, TError,{patientId: string;orderId: string;data: CreateShippingLabelDoctorApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdLabels>>, TError,{patientId: string;orderId: string;data: CreateShippingLabelDoctorApiInContract}, TContext> => {

const mutationKey = ['postPatientsPatientIdPharmacyOrdersOrderIdLabels'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdLabels>>, {patientId: string;orderId: string;data: CreateShippingLabelDoctorApiInContract}> = (props) => {
          const {patientId,orderId,data} = props ?? {};

          return  postPatientsPatientIdPharmacyOrdersOrderIdLabels(patientId,orderId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPatientsPatientIdPharmacyOrdersOrderIdLabelsMutationResult = NonNullable<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdLabels>>>
    export type PostPatientsPatientIdPharmacyOrdersOrderIdLabelsMutationBody = CreateShippingLabelDoctorApiInContract
    export type PostPatientsPatientIdPharmacyOrdersOrderIdLabelsMutationError = void | ErrorApiOutContract

    /**
 * @summary Create a ZPL shipping label. The ZPL is returned to the caller for local Zebra printing.
 */
export const usePostPatientsPatientIdPharmacyOrdersOrderIdLabels = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdLabels>>, TError,{patientId: string;orderId: string;data: CreateShippingLabelDoctorApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdLabels>>,
        TError,
        {patientId: string;orderId: string;data: CreateShippingLabelDoctorApiInContract},
        TContext
      > => {

      const mutationOptions = getPostPatientsPatientIdPharmacyOrdersOrderIdLabelsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Confirm shipment: notify Scriptly and record tracking
 */
export const postPatientsPatientIdPharmacyOrdersOrderIdShipments = (
    patientId: string,
    orderId: string,
    confirmShipmentDoctorApiInContract: ConfirmShipmentDoctorApiInContract,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<ConfirmShipmentDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/pharmacy/orders/${encodeURIComponent(String(orderId))}/shipments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmShipmentDoctorApiInContract, signal
    },
      options);
    }
  


export const getPostPatientsPatientIdPharmacyOrdersOrderIdShipmentsMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdShipments>>, TError,{patientId: string;orderId: string;data: ConfirmShipmentDoctorApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdShipments>>, TError,{patientId: string;orderId: string;data: ConfirmShipmentDoctorApiInContract}, TContext> => {

const mutationKey = ['postPatientsPatientIdPharmacyOrdersOrderIdShipments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdShipments>>, {patientId: string;orderId: string;data: ConfirmShipmentDoctorApiInContract}> = (props) => {
          const {patientId,orderId,data} = props ?? {};

          return  postPatientsPatientIdPharmacyOrdersOrderIdShipments(patientId,orderId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPatientsPatientIdPharmacyOrdersOrderIdShipmentsMutationResult = NonNullable<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdShipments>>>
    export type PostPatientsPatientIdPharmacyOrdersOrderIdShipmentsMutationBody = ConfirmShipmentDoctorApiInContract
    export type PostPatientsPatientIdPharmacyOrdersOrderIdShipmentsMutationError = void | ErrorApiOutContract

    /**
 * @summary Confirm shipment: notify Scriptly and record tracking
 */
export const usePostPatientsPatientIdPharmacyOrdersOrderIdShipments = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdShipments>>, TError,{patientId: string;orderId: string;data: ConfirmShipmentDoctorApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdShipments>>,
        TError,
        {patientId: string;orderId: string;data: ConfirmShipmentDoctorApiInContract},
        TContext
      > => {

      const mutationOptions = getPostPatientsPatientIdPharmacyOrdersOrderIdShipmentsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Reprint a ZPL shipping label: retrieves the existing label from ShipEngine without purchasing a new one.
 */
export const getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey = (
    patientId: string,
    orderId: string,
    labelThirdPartyKey: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<CreateShippingLabelDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/pharmacy/orders/${encodeURIComponent(String(orderId))}/labels/${encodeURIComponent(String(labelThirdPartyKey))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyInfiniteQueryKey = (patientId?: string,
    orderId?: string,
    labelThirdPartyKey?: string,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/patients/${patientId}/pharmacy/orders/${orderId}/labels/${labelThirdPartyKey}`
    ] as const;
    }

export const getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyQueryKey = (patientId?: string,
    orderId?: string,
    labelThirdPartyKey?: string,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/patients/${patientId}/pharmacy/orders/${orderId}/labels/${labelThirdPartyKey}`
    ] as const;
    }

    
export const getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>>, TError = void | ErrorApiOutContract>(patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyInfiniteQueryKey(patientId,orderId,labelThirdPartyKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>> = ({ signal }) => getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey(patientId,orderId,labelThirdPartyKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId && orderId && labelThirdPartyKey), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>>
export type GetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reprint a ZPL shipping label: retrieves the existing label from ShipEngine without purchasing a new one.
 */

export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyInfiniteQueryOptions(patientId,orderId,labelThirdPartyKey,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Reprint a ZPL shipping label: retrieves the existing label from ShipEngine without purchasing a new one.
 */
export const prefetchGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyInfiniteQueryOptions(patientId,orderId,labelThirdPartyKey,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError = void | ErrorApiOutContract>(patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyQueryKey(patientId,orderId,labelThirdPartyKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>> = ({ signal }) => getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey(patientId,orderId,labelThirdPartyKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId && orderId && labelThirdPartyKey), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>>
export type GetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>,
          TError,
          Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reprint a ZPL shipping label: retrieves the existing label from ShipEngine without purchasing a new one.
 */

export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyQueryOptions(patientId,orderId,labelThirdPartyKey,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Reprint a ZPL shipping label: retrieves the existing label from ShipEngine without purchasing a new one.
 */
export const prefetchGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyQuery = async <TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyQueryOptions(patientId,orderId,labelThirdPartyKey,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError = void | ErrorApiOutContract>(patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyQueryKey(patientId,orderId,labelThirdPartyKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>> = ({ signal }) => getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey(patientId,orderId,labelThirdPartyKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>>
export type GetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspenseQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reprint a ZPL shipping label: retrieves the existing label from ShipEngine without purchasing a new one.
 */

export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspense<TData = Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspenseQueryOptions(patientId,orderId,labelThirdPartyKey,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>>, TError = void | ErrorApiOutContract>(patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyInfiniteQueryKey(patientId,orderId,labelThirdPartyKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>> = ({ signal }) => getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey(patientId,orderId,labelThirdPartyKey, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>>
export type GetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reprint a ZPL shipping label: retrieves the existing label from ShipEngine without purchasing a new one.
 */

export function useGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>>, TError = void | ErrorApiOutContract>(
 patientId: string,
    orderId: string,
    labelThirdPartyKey: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeySuspenseInfiniteQueryOptions(patientId,orderId,labelThirdPartyKey,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Void a shipping label: cancels billing with the carrier and reverts order to Confirmed
 */
export const deletePatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey = (
    patientId: string,
    orderId: string,
    labelThirdPartyKey: string,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<VoidShippingLabelDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/pharmacy/orders/${encodeURIComponent(String(orderId))}/labels/${encodeURIComponent(String(labelThirdPartyKey))}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeletePatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError,{patientId: string;orderId: string;labelThirdPartyKey: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError,{patientId: string;orderId: string;labelThirdPartyKey: string}, TContext> => {

const mutationKey = ['deletePatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, {patientId: string;orderId: string;labelThirdPartyKey: string}> = (props) => {
          const {patientId,orderId,labelThirdPartyKey} = props ?? {};

          return  deletePatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey(patientId,orderId,labelThirdPartyKey,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deletePatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>>
    
    export type DeletePatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyMutationError = void | ErrorApiOutContract

    /**
 * @summary Void a shipping label: cancels billing with the carrier and reverts order to Confirmed
 */
export const useDeletePatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>, TError,{patientId: string;orderId: string;labelThirdPartyKey: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKey>>,
        TError,
        {patientId: string;orderId: string;labelThirdPartyKey: string},
        TContext
      > => {

      const mutationOptions = getDeletePatientsPatientIdPharmacyOrdersOrderIdLabelsLabelThirdPartyKeyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update the shipping address on a pharmacy order. Blocked if an active (non-voided) label exists.
 */
export const putPatientsPatientIdPharmacyOrdersOrderIdShippingAddress = (
    patientId: string,
    orderId: string,
    shipToAddressOverrideStaffApiInContract: ShipToAddressOverrideStaffApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/pharmacy/orders/${encodeURIComponent(String(orderId))}/shipping-address`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: shipToAddressOverrideStaffApiInContract
    },
      options);
    }
  


export const getPutPatientsPatientIdPharmacyOrdersOrderIdShippingAddressMutationOptions = <TError = ErrorApiOutContract | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdPharmacyOrdersOrderIdShippingAddress>>, TError,{patientId: string;orderId: string;data: ShipToAddressOverrideStaffApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdPharmacyOrdersOrderIdShippingAddress>>, TError,{patientId: string;orderId: string;data: ShipToAddressOverrideStaffApiInContract}, TContext> => {

const mutationKey = ['putPatientsPatientIdPharmacyOrdersOrderIdShippingAddress'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPatientsPatientIdPharmacyOrdersOrderIdShippingAddress>>, {patientId: string;orderId: string;data: ShipToAddressOverrideStaffApiInContract}> = (props) => {
          const {patientId,orderId,data} = props ?? {};

          return  putPatientsPatientIdPharmacyOrdersOrderIdShippingAddress(patientId,orderId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPatientsPatientIdPharmacyOrdersOrderIdShippingAddressMutationResult = NonNullable<Awaited<ReturnType<typeof putPatientsPatientIdPharmacyOrdersOrderIdShippingAddress>>>
    export type PutPatientsPatientIdPharmacyOrdersOrderIdShippingAddressMutationBody = ShipToAddressOverrideStaffApiInContract
    export type PutPatientsPatientIdPharmacyOrdersOrderIdShippingAddressMutationError = ErrorApiOutContract | void

    /**
 * @summary Update the shipping address on a pharmacy order. Blocked if an active (non-voided) label exists.
 */
export const usePutPatientsPatientIdPharmacyOrdersOrderIdShippingAddress = <TError = ErrorApiOutContract | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPatientsPatientIdPharmacyOrdersOrderIdShippingAddress>>, TError,{patientId: string;orderId: string;data: ShipToAddressOverrideStaffApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPatientsPatientIdPharmacyOrdersOrderIdShippingAddress>>,
        TError,
        {patientId: string;orderId: string;data: ShipToAddressOverrideStaffApiInContract},
        TContext
      > => {

      const mutationOptions = getPutPatientsPatientIdPharmacyOrdersOrderIdShippingAddressMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Re-publish a fulfillment request for a QuickMD Pharmacy (Scriptly) order dispensed at the pharmacist's pharmacy
(404 otherwise) and return before the partner call is made. Allowed for `onhold` orders, or `sent`
orders unchanged for 15 minutes; a `sent` order inside that window returns 200 without publishing (its attempt
may still be in flight). Orders already submitted to the pharmacy return 409. The worker serializes attempts per order and skips orders already confirmed.
 */
export const postPatientsPatientIdPharmacyOrdersOrderIdFulfillment = (
    patientId: string,
    orderId: string,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<void>(
      {url: `https://providers-api.api.quick.md/api/v1/patients/${encodeURIComponent(String(patientId))}/pharmacy/orders/${encodeURIComponent(String(orderId))}/fulfillment`, method: 'POST', signal
    },
      options);
    }
  


export const getPostPatientsPatientIdPharmacyOrdersOrderIdFulfillmentMutationOptions = <TError = ErrorApiOutContract | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdFulfillment>>, TError,{patientId: string;orderId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdFulfillment>>, TError,{patientId: string;orderId: string}, TContext> => {

const mutationKey = ['postPatientsPatientIdPharmacyOrdersOrderIdFulfillment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdFulfillment>>, {patientId: string;orderId: string}> = (props) => {
          const {patientId,orderId} = props ?? {};

          return  postPatientsPatientIdPharmacyOrdersOrderIdFulfillment(patientId,orderId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPatientsPatientIdPharmacyOrdersOrderIdFulfillmentMutationResult = NonNullable<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdFulfillment>>>
    
    export type PostPatientsPatientIdPharmacyOrdersOrderIdFulfillmentMutationError = ErrorApiOutContract | void

    /**
 * @summary Re-publish a fulfillment request for a QuickMD Pharmacy (Scriptly) order dispensed at the pharmacist's pharmacy
(404 otherwise) and return before the partner call is made. Allowed for `onhold` orders, or `sent`
orders unchanged for 15 minutes; a `sent` order inside that window returns 200 without publishing (its attempt
may still be in flight). Orders already submitted to the pharmacy return 409. The worker serializes attempts per order and skips orders already confirmed.
 */
export const usePostPatientsPatientIdPharmacyOrdersOrderIdFulfillment = <TError = ErrorApiOutContract | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdFulfillment>>, TError,{patientId: string;orderId: string}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPatientsPatientIdPharmacyOrdersOrderIdFulfillment>>,
        TError,
        {patientId: string;orderId: string},
        TContext
      > => {

      const mutationOptions = getPostPatientsPatientIdPharmacyOrdersOrderIdFulfillmentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    